import { Dispatch, SetStateAction } from "react";
import { IOnboardingChoices } from "~/types/account";
import { SelectCategory } from "./SelectCategory";
import { ColorScheme } from "./color-scheme";
import { Category } from "./category";
import { DescribedWord } from "./described-word";
import { Region } from "./region";

export const onboardingStepsMap = {
  SELECT_CATEGORY: 1,
  REGION: 2,
};

export const customizationStepsMap = {
  COLOR_SCHEME: 1,
  CATEGORY: 2,
  DESCRIBED_WORD: 3,
  REGION: 4,
};

export type StepComponentProps = {
  onboardingChoices: IOnboardingChoices | undefined;
  setOnboardingChoices: Dispatch<
    SetStateAction<IOnboardingChoices | undefined>
  >;
};

interface Step {
  titleKey: string;
  component: (props: StepComponentProps) => JSX.Element | null;
}

export const onboardingSteps: Step[] = [
  {
    titleKey: "onboarding.store_creation_title",
    component: () => null,
  },
  {
    titleKey: "onboarding.category_title",
    component: SelectCategory,
  },
  {
    titleKey: "onboarding.customization-store.region.store_region_title",
    component: Region,
  },
];

export const customizationSteps: Step[] = [
  {
    titleKey:
      "onboarding.customization-store.color-scheme-step.customization_store_title",
    component: () => null,
  },
  {
    titleKey:
      "onboarding.customization-store.color-scheme-step.store_color_scheme_title",
    component: ColorScheme,
  },
  {
    titleKey: "onboarding.customization-store.category.store_category_title",
    component: Category,
  },

  {
    titleKey:
      "onboarding.customization-store.described-word.store_best_described_word_title",
    component: DescribedWord,
  },
  {
    titleKey: "onboarding.customization-store.region.store_region_title",
    component: Region,
  },
];
